import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {stripAmountFormatting} from '../../dst-amount.util';
import {toSaveString, safeEntityId} from '../../dst-save.util';

import { safeJsonInput } from '../../../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'dst-template-sec367b-id192',
    templateUrl: './template-sec367b-id192.component.html',
    styleUrls: ['../template-shared.scss', './template-sec367b-id192.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec367bId192Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  // remove me after commit

  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form192!: UntypedFormGroup;
  selectedOptionID!: Event;
  dcnId!: number;
  startLoader: boolean = false;
  statementId: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;
  beginDate!: Date;
  endDate!: Date;
  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  branchEntity!: DSTEntityDetails | null;
  DisplayDate: any = '';
  section4text: string = '';
  Shares: string = '';
  PercentageX: string = '';
  PercentageY: string = '';
  propertyValBasisOptions: any[] = [];
  selectedBasis: number = -1;
  selectedBasisItem: any = null;
  selectedCurrency: number = -1;
  selectedCurrencyItem: any = null;
  currencyOptions: any[] = [];
  stockType: any[] = [];
  selectedStockType: number = -1;
  selectedStockTypeItem: any = null;
  showDREMsg: boolean = false;
  DREMsg: string = '';
  entityNameChangeOnDate: boolean = false;
    nameChangeChecked: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private headerService: TemplateHeaderService,
              private trackerTabsService: TrackerTabsService,
              private cdref: ChangeDetectorRef) {
  }

  get additionalPropsDetails(): UntypedFormArray {
    return this.form192.get('main')?.get('additionalPropsDetails') as UntypedFormArray;
  }

  ngOnInit(): void {
    this.editMode = false;
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    this.form192 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      main: this.formBuilder.group({
        DisplayDate: [''],
        section4text: [''],
        propertyValBasis: [''],
        currency1: [''],
        Shares: [''],
        PercentageX: [''],
        PercentageY: [''],
        additionalPropsDetails: this.formBuilder.array([
          this.formBuilder.group({
            description: [''],
            transferorBasis: ['']
          })
        ]),
      }),
    });
    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        console.log(data);
        data.forEach((element, index) => {
          this.propertyValBasisOptions.push({
            value: element.id,
            label: element.text,
            index: index
          });
        });
        this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec367b-id192.parse1');
      }, () => {

      }, () => {
        if (this.attMap['Basis']) {
          const updatedData = this.updateDropdownList(this.propertyValBasisOptions, this.attMap['Basis'][0]);
          this.propertyValBasisOptions = updatedData.dropdownData;
          this.selectedBasis = updatedData.index;
          this.selectedBasisItem = this.propertyValBasisOptions.find((i: any) => i.selected) || null;
        }
      });

    this.sharedService.getStockType().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.stockType.push({
            value: element.id,
            label: element.text,
            text: element.text
          });
        });
        this.stockType = JSON.parse(JSON.stringify(this.stockType));
      }, () => {

      }, () => {
        this.applyStockTypeFromAttMap();
      });
    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach((element, index) => {
          this.currencyOptions.push({
            value: element.id,
            label: element.text,
            index: index,
          });
        });
        const usdIndex: number = data.findIndex((c: any) => c.id === 84);
        if (usdIndex > 0) {
          this.currencyOptions[usdIndex].selected = true;
          this.currencyOptions = safeJsonInput<any>(JSON.stringify(this.currencyOptions), null, 'template-sec367b-id192.parse2');
          this.selectedCurrency = this.currencyOptions[usdIndex].value;
          this.selectedCurrencyItem = this.currencyOptions[usdIndex];
        }
      }, () => {

      }, () => {
        if (this.attMap['Currency']) {
          this.attMap['Currency'].forEach((element: any, index: number) => {
            switch (index) {
              case 0:
                let updatedData = this.updateDropdownList(this.currencyOptions, element);
                this.currencyOptions = updatedData.dropdownData;
                this.selectedCurrency = updatedData.index;
                this.selectedCurrencyItem = this.currencyOptions.find((i: any) => i.selected) || null;
                break;
            }
          });
        }
      });
    this.statementId = this.sharedService.getFormData()?.statementid.toString() || '';
  }

  updateDropdownList(currentOptions: any, element: string) {
    const updateList: any[] = [];
    let selectedIndex = -1;
    const list = Array.isArray(currentOptions) ? currentOptions : [];
    list.forEach((el: any, index: number) => {
      const displayText = el.text ?? el.label;
      if (parseInt(element, 10) === el.value) {
        updateList.push({
          value: el.value,
          label: displayText,
          text: displayText,
          index: index,
          selected: true,
        });
        selectedIndex = el.value;
      } else {
        updateList.push({
          value: el.value,
          label: displayText,
          text: displayText,
          index: index,
        });
      }
    });
    return {dropdownData: updateList, index: selectedIndex};
  }

  private applyStockTypeFromAttMap(): void {
    if (!this.attMap['StockType'] || !this.stockType.length) {
      return;
    }
    const updatedData = this.updateDropdownList(this.stockType, this.attMap['StockType'][0]);
    this.stockType = JSON.parse(JSON.stringify(updatedData.dropdownData));
    this.selectedStockType = updatedData.index;
    this.selectedStockTypeItem = this.stockType.find((i: any) => i.selected) || null;
  }

  private extractDropdownSelection(event: any): any {
    if (!event?.selected) {
      return null;
    }
    return Array.isArray(event.selected) ? event.selected[0] : event.selected;
  }

  trackByDropdownValue(index: number, item: any): number | string {
    return item?.value ?? index;
  }

  selectBasisOption(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedBasis = change?.value;
  }

  selectStockType(event: any) {
    const change = this.extractDropdownSelection(event);
    if (!change) {
      return;
    }
    this.selectedStockType = change.value;
    this.selectedStockTypeItem = this.stockType.find((i: any) => i.value === change.value) ?? change;
    this.cdref.detectChanges();
  }

  addAdditionalPropDetails(): void {
    this.additionalPropsDetails.push(this.formBuilder.group({
      description: [''],
      transferorBasis: [''],
    }));
  }

  removeAdditionalPropDetailsAt(index: number): void {
    this.additionalPropsDetails.removeAt(index);
  }

  /**
   * Replace the starter blank row with one group per saved description / amount.
   * clear()+push leaves the first input bound to the removed empty group, so the
   * first saved row stays blank in edit mode.
   */
  private applyAdditionalPropRows(): void {
    const descriptions: string[] = this.attMap['Desc1'] || [];
    const basis: string[] = this.attMap['BasisAmt1'] || [];
    const count = Math.max(descriptions.length, basis.length);
    if (!count) {
      return;
    }
    const rows = Array.from({length: count}, (_value, index) => this.formBuilder.group({
      description: [descriptions[index] ?? ''],
      transferorBasis: [stripAmountFormatting(basis[index])]
    }));
    (this.form192.get('main') as UntypedFormGroup)
      .setControl('additionalPropsDetails', this.formBuilder.array(rows));
    // AppKit projects the input after the first write, so push the saved
    // values again once each row's field exists.
    setTimeout(() => {
      rows.forEach((group, index) => {
        const control = this.additionalPropsDetails?.at(index);
        if (!control) {
          return;
        }
        control.get('description')?.setValue(group.get('description')?.value, {emitEvent: false});
        control.get('transferorBasis')?.setValue(group.get('transferorBasis')?.value, {emitEvent: false});
      });
      this.cdref.detectChanges();
    });
  }

  dummyFunc(event: any): void {

  }

  currencyOneChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency = change?.value;
  }

  ngAfterViewInit(): void {
    if (this.sharedService.getFormStateByFormId(192)?.isChild) {
      this.sharedService.getLoadStatementData(192).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: StmtData) => {
        this.sharedService.setFormData(data, 192);
        this.loadStmtData();
      }, (eMsg: string) => {
        console.log(eMsg);
        this.dstSharedService.showAlert('error', eMsg);
      });
    } else {
      this.loadStmtData();
    }
  }

  private loadStmtData(): void {
    const data: StmtData | undefined = this.sharedService.getFormData(192);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      this.editMode = true;

      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.secondaryleid);
              break;
            case 1:
              element.fillLEID(data.primaryleid);
              break;
            case 2:
              if (data.branchleid) {
                element.fillLEID(data.branchleid);
              }
              break;
          }
        });
      });

      this.populateFields(data);

    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      const formId = this.sharedService.getActiveFormState().formId;
      const taxYear = (this.sharedService.getActiveFormState()?.taxYear || 2020).toString();
      const cseId = this.sharedService.getActiveFormState().cseId;

      setTimeout(() => {
        this.leidComponents.toArray()[1].fillLEID(this.sharedService.leid);
      });

      this.startLoader = true;
      this.sharedService.getDSTTrackerRequirementData(taxYear, cseId, formId!).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: StmtData) => {
        data && this.populateFields(data);
      }, () => { this.startLoader = false; }, () => { this.startLoader = false; });
    }else{
      this.nameChangeChecked = true;
    }
  }

  populateFields(data: StmtData): void {
    data.children?.forEach((stmt: StmtAttrData) => {
      if (this.attMap[stmt.attributeName] == undefined) {
        this.attMap[stmt.attributeName] = [];
      }
      if (stmt.attributeValue != null) {
        this.attMap[stmt.attributeName].push(stmt.attributeValue);
      }
    });
    if (this.attMap['section4text'] && this.attMap['section4text'][0]) {
      this.section4text = this.attMap['section4text'][0];
    }

    if (this.attMap['Shares'] && this.attMap['Shares'][0]) {
      this.Shares = this.attMap['Shares'][0] ?? '';
    }

    if (this.attMap['PercentageX'] && this.attMap['PercentageX'][0]) {
      this.PercentageX = this.attMap['PercentageX'][0] ?? '';
    }

    if (this.attMap['PercentageY'] && this.attMap['PercentageY'][0]) {
      this.PercentageY = this.attMap['PercentageY'][0] ?? '';
    }

    if (this.attMap['DisplayDate'] && this.attMap['DisplayDate'][0] && this.attMap['DisplayDate'][0] !== '') {
      this.DisplayDate = new Date(this.attMap['DisplayDate'][0].replace(/-/g, '\/').replace(/T.+/, ''));
    }

    this.applyAdditionalPropRows();

    if (this.attMap['Basis']) {
      const updatedData = this.updateDropdownList(this.propertyValBasisOptions, this.attMap['Basis'][0]);
      this.propertyValBasisOptions = updatedData.dropdownData;
      this.selectedBasis = updatedData.index;
    }

    if (this.attMap['Currency']) {
      this.attMap['Currency'].forEach((element: any, index: number) => {
        switch (index) {
          case 0:
            let updatedData = this.updateDropdownList(this.currencyOptions, element);
            this.currencyOptions = updatedData.dropdownData;
            this.selectedCurrency = updatedData.index;
            break;
        }
      });
    }

    this.applyStockTypeFromAttMap();

    this.cdref.detectChanges();
  }

  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.DisplayDate = null;
        this.form192.get('main')?.get('DisplayDate')?.setValue(null);
        this.form192.get('main')?.get('DisplayDate')?.markAsTouched();
        break;
      default:
        break;
    }
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();

    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  private forceClearDatePickerInputs(index: number): void {
    try {
      // Find the date picker input field by form control name
      const formControlNames = ['DisplayDate'];
      const formControlName = formControlNames[index - 1];

      if (formControlName) {
        // Try to find the input field within the date picker component
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  dateChange(event: any, index: number) {
    switch (index) {
      case 1:
        this.DisplayDate = event.startDate.format('YYYY-MM-DD');
        const leids: string = this.sharedService.concatLEIDs([this.transferee!, this.transferor!]);
        if (!leids) {
          break;
        }
        this.startLoader = true;
        this.entityNameChangeOnDate = true;
        this.sharedService.checkForEntityNameChange(this.statementId,
          leids,
          this.DisplayDate,
          this.sharedService.getActiveFormState().taxYear.toString()
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
          if (response) {
            for (let i = 0; i < leids.split(',').length; i++) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.transferee!, this.transferor!], response[i].TAXTYPECODE);
            }
          }
          this.nameChangeChecked = true;
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.dstSharedService.showAlert('error', error.message);
        }).add(() => {
          this.startLoader = false;
        });

        break;
    }
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferor = selectedTransferor;
    this.headerComponent.loadConsolGroups(selectedTransferor?.LEID!,this.dcnId);
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;

    if (this.DisplayDate && this.transferor?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferor.LEID,
        this.DisplayDate,
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.transferor!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.transferor!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.DisplayDate) {
      this.nameChangeChecked = true;

    }  else {
      this.entityNameChangeOnDate = false;
    }
  }

  onTransfereeChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferee = selectedTransferor;
    if (!selectedTransferor) {
      return;
    }

    if (this.DisplayDate && this.transferee?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferee.LEID,
        this.DisplayDate,
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.transferee!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.transferee!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.DisplayDate) {
      this.nameChangeChecked = true;

    }  else {
      this.entityNameChangeOnDate = false;
    }
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee!, this.transferor!]);
    this.showDREMsg = !!this.DREMsg;
  }

  onFormOptionChanged(selectedOptionID: Event): void {
    this.selectedOptionID = selectedOptionID;
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  onBranchEntityChanged(selectedBranch: DSTEntityDetails | null): void {
    this.branchEntity = selectedBranch;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferor, this.transferee])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferee),
        'secondaryEntityId': safeEntityId(this.transferor),
        'branchEntityId': safeEntityId(this.branchEntity),
        'comments': '',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'attachmentFileName': '',
      };

      const desc: string[] = [];
      const basisAmt: string[] = [];
      const fairMarketVal: string[] = [];
      this.additionalPropsDetails.controls.forEach(element => {
        desc.push(element.value.description);
        basisAmt.push(element.value.transferorBasis !== null ? stripAmountFormatting(element.value.transferorBasis.toString()) : '');

      });
      const jsonObject = {
        'CheckFor351Transfer': '0',
        'DisplayDate': this.DisplayDate !== null && this.DisplayDate !== '' ? this.DisplayDate.startDate ? this.DisplayDate.startDate.format('YYYY-MM-DD') : this.DisplayDate : '',
        'section4text': toSaveString(this.section4text),
        'Desc1': desc.some((value) => value !== null && value !== undefined && value !== '') ? desc : [''],
        'BasisAmt1': basisAmt,
        'Currency': toSaveString(this.selectedCurrency),
        'Basis': toSaveString(this.selectedBasis),
        'Shares': this.Shares !== null && this.Shares !== undefined ? toSaveString(this.Shares) : '',
        'PercentageX': this.PercentageX !== null && this.PercentageX !== undefined ? toSaveString(this.PercentageX) : '',
        'PercentageY': this.PercentageY !== null && this.PercentageY !== undefined ? toSaveString(this.PercentageY) : '',
        'StockType': toSaveString(this.selectedStockType),
      };
      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
        this.startLoader = false;
      });
    }
  }

  isFormValid(placeholder: boolean): boolean {
    if (placeholder) {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferee');
        return false;
      }
    } else {
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferor');
        return false;
      }
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferee');
        return false;
      }

      if (this.DisplayDate === '' || this.DisplayDate === null) {
        this.dstSharedService.showAlert('error', 'Please Enter a Date');
        return false;
      }

      if (this.selectedStockType === -1) {
        this.dstSharedService.showAlert('error', 'Please select Stock Type');
        return false;
      }
      if (this.Shares === '') {
        this.dstSharedService.showAlert('error', 'Please Enter number of Shares');
        return false;
      }
    }

    return true;
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.text || item?.label || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }
}


